export default {
  meta() {
    if (!this.preview) {
      return {
        title: '404',
        meta: {
          description: {
            name: 'description',
            content: 'Page not found',
          },
        },
      };
    }
    const { seo } = this.preview.jsonSchema;
    const title = seo?.seoTitle || this.preview.title;
    const description = seo?.seoDescription || this.preview.title;

    return {
      title,
      meta: {
        description: {
          name: 'description',
          content: description,
        },
      },
    };
  },
};
